import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';
import {OrganizationTreeSelect} from "../dip/organization-tree-select";
import {HttpClient} from "@angular/common/http";
import {User} from "../models/user";

@Injectable({providedIn: 'root'})
export class UserService extends AbstractProdSelectService implements IProdGridService {
  override selectDataUrl: string = 'users';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'username'
  };

  constructor(public override httpClient: HttpClient, private organizationTreeSelect: OrganizationTreeSelect) {
    super(httpClient);
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: User[], totalCount: number }, success: boolean }>(`/api/users`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post<any>('/api/user', values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    return this.httpClient.patch<any>(`/api/user/${id}`, values);
  }

  prodGridRemove(id: number): Observable<Object> {
    return this.httpClient.delete<any>(`/api/user/${id}`, {params: {organization: this.organizationTreeSelect.company.id}});
  }

  distributorGridRemove(id: number, distributor: number): Observable<Object> {
    return this.httpClient.delete<any>(`/api/user/${id}`, {params: {organization: distributor}});
  }

  changePassword(oldPassword: string, newPassword: string, confirmPassword: string) {
    return this.httpClient.post<any>('/api/user/passwordChange', {
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmPassword
    })
  }

  resetPassword(username: string, password: string, token: string) {
    return this.httpClient.post<any>('/api/tokenPasswordChange', {
      username: username,
      password: password,
      token: token
    })
  }

  newPasswordRequest(userId: number): Observable<Object> {
    return this.httpClient.post(`/api/user/${userId}/newPasswordRequest`, null);
  }

  forgotPassword(username: string): Observable<object> {
    return this.httpClient.get('/api/forgotPassword', {params: {username: username}});
  }

  getOrganizationFilter(): HttpFilterParam[] {
    let ids = [];
    ids = ids.concat(this.organizationTreeSelect.ids);
    if (this.organizationTreeSelect.company) {
      ids.push(this.organizationTreeSelect.company.id);
    }

    if (this.organizationTreeSelect.distributor || this.organizationTreeSelect.organizationTreeSelect$.value === -1) {
      if (this.organizationTreeSelect.organizationTreeSelect$.value === -1 || this.organizationTreeSelect.distributor.id === -1) {
        return [
          new HttpFilterParam({
            property: 'groups.organizationUserGroup.organization.distributor',
            operator: 'isNull',
            value: null
          }),
          new HttpFilterParam({
            property: 'groups.organizationUserGroup.organization.organization.distributor',
            operator: 'isNull',
            value: null
          })
        ];
      }
      ids = ids.concat(this.organizationTreeSelect.distributor.distributorCompanies.map(company => {
        let ids = company.subOrganizations.map(site => {
          return site.id;
        });

        ids.push(company.id);

        return ids;
      }).flat()).filter(f => f);
    }

    return [new HttpFilterParam({
      property: 'groups.organizationUserGroup.organization',
      operator: 'in',
      value: ids
    })];
  }

  patchNotifierOrganization(values: any, id: number) {
    return this.httpClient.patch<any>(`/api/userNotifierOrganization/${id}`, values);
  }
}
